const MAP_CACHE_TTL_MS = 1000 * 60 * 60 * 6;
const MAP_CACHE_VERSION = 'v1';

const buildMapCacheKey = (key) => {
    const scope = process.env.REACT_APP_BASE_URL || 'default';
    return `oysterpl8:${MAP_CACHE_VERSION}:${scope}:${key}`;
};

export const readMapCache = (key, ttlMs = MAP_CACHE_TTL_MS) => {
    try {
        const raw = window.localStorage.getItem(buildMapCacheKey(key));
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        const isExpired = !parsed?.savedAt || (Date.now() - parsed.savedAt > ttlMs);
        if (isExpired) {
            return null;
        }
        return parsed.data ?? null;
    } catch (e) {
        return null;
    }
};

export const writeMapCache = (key, data) => {
    try {
        window.localStorage.setItem(buildMapCacheKey(key), JSON.stringify({
            savedAt: Date.now(),
            data
        }));
    } catch (e) {
        // Ignore storage quota/serialization issues and continue with network data.
    }
};
